import queryString from 'query-string'
import dayjs from 'dayjs'
export const getUrlWithParams = (url, newParams) => {
    const params = new URLSearchParams()
    if (newParams && newParams.length > 0) {
        newParams.forEach((x) => params.set(x.name, x.value))
    }
    return newParams && newParams.length > 0 ? `${url}?${params.toString()}` : url
}

export const convertDate = (dateString) => dayjs(dateString).format('DD.MM.YYYY')
export const convertTime = (dateTimeString) => dayjs(dateTimeString).format('HH:mm')

export const convertDateTime = (dateTimeSting) => dayjs(dateTimeSting).format('DD.MM.YYYY HH:mm')

export const declOfNum = (n, titles) =>
    titles[
        // eslint-disable-next-line no-nested-ternary
        n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2
    ]
export const getColorPrefix = (title) => {
    if (title.includes('м. ')) return 'м.'
    if (title.includes('г. ')) return 'г.'
    return ''
}
export const generateTime = (date) => {
    const dateInstance = new Date(date)
    return dateInstance.toTimeString().match(/\d{2}:\d{2}/)[0]
}
const urlRegular = /^(\w+:\/\/[^/?]+)?(.*?)(\?.+)?$/
const relativeUrlRegular = /^(\/\/[^/?]+)(.*?)(\?.+)?$/

const normalizeParts = (parts) =>
    parts
        .filter((part) => typeof part === 'string' || typeof part === 'number')
        .map((part) => `${part}`)
        .filter((part) => part)

const parseParts = (parts, options) => {
    const { protocolRelative } = options

    const partsStr = parts.join('/')
    const urlRegExp = protocolRelative ? relativeUrlRegular : urlRegular
    const [, prefix = '', pathname = '', suffix = ''] = partsStr.match(urlRegExp) || []

    return {
        prefix,
        pathname: {
            parts: pathname.split('/').filter((part) => part !== ''),
            hasLeading: suffix ? /^\/\/+/.test(pathname) : /^\/+/.test(pathname),
            hasTrailing: suffix ? /\/\/+$/.test(pathname) : /\/+$/.test(pathname)
        },
        suffix
    }
}

const buildUrl = (parsedParts, options) => {
    const { prefix, pathname, suffix } = parsedParts
    const { parts: pathnameParts, hasLeading, hasTrailing } = pathname
    const { leadingSlash, trailingSlash } = options
    const addLeading = leadingSlash === true || (leadingSlash === 'keep' && hasLeading)
    const addTrailing = trailingSlash === true || (trailingSlash === 'keep' && hasTrailing)
    let url = prefix
    if (pathnameParts.length > 0) {
        if (url || addLeading) {
            url += '/'
        }

        url += pathnameParts.join('/')
    }

    if (addTrailing) {
        url += '/'
    }

    if (!url && addLeading) {
        url += '/'
    }

    // noinspection JSUnresolvedReference
    const query = { ...queryString.parse(suffix, options.queryOptions), ...options.query }
    // noinspection JSUnresolvedReference
    const queryStr = queryString.stringify(query, options.queryOptions)

    if (queryStr) {
        url += `?${queryStr}`
    }

    return url
}

export const urlCombine = (...parts) => {
    const lastArg = parts[parts.length - 1]
    let options
    if (lastArg && typeof lastArg === 'object') {
        options = lastArg
        // eslint-disable-next-line no-param-reassign
        parts = parts.slice(0, -1)
    }

    options = {
        leadingSlash: true,
        trailingSlash: false,
        protocolRelative: false,
        ...options
    }

    // eslint-disable-next-line no-param-reassign
    parts = normalizeParts(parts)
    const parsedParts = parseParts(parts, options)
    return buildUrl(parsedParts, options)
}
